import Vue from 'vue'

const KEY = 'tcp_cart'
export const cartBus = new Vue()

function read() {
	try {
		const raw = window.localStorage.getItem(KEY)
		const items = raw ? JSON.parse(raw) : []
		return Array.isArray(items) ? items : []
	} catch (e) {
		return []
	}
}

function write(items) {
	window.localStorage.setItem(KEY, JSON.stringify(items))
	cartBus.$emit('change', items)
}

const cart = {
	items() {
		return read()
	},
	count() {
		return read().reduce((sum, item) => sum + Number(item.quantity || 0), 0)
	},
	subtotal() {
		return read().reduce((sum, item) => sum + (Number(item.price) * Number(item.quantity)), 0)
	},
	add(product, quantity) {
		const qty = Math.max(1, Number(quantity) || 1)
		const items = read()
		const existing = items.find(item => item.id === product.id)
		const stock = Number(product.stock || 0)
		if (existing) {
			existing.quantity = Math.min(stock, existing.quantity + qty)
			existing.price = product.price
			existing.stock = stock
		} else {
			items.push({
				id: product.id,
				name: product.name,
				presentation: product.presentation || '',
				price: product.price,
				image_url: product.image_url || null,
				stock: stock,
				quantity: Math.min(stock, qty)
			})
		}
		write(items)
		return items
	},
	update(id, quantity) {
		const items = read().map(item => {
			if (item.id !== id) return item
			const qty = Math.max(1, Math.min(Number(item.stock || 99), Number(quantity) || 1))
			return Object.assign({}, item, { quantity: qty })
		})
		write(items)
	},
	remove(id) {
		write(read().filter(item => item.id !== id))
	},
	clear() {
		write([])
	}
}

export default cart
